import React from "react";
import { Routes, Route } from "react-router-dom";
import ListUserViewVrHistory from "../Components/User View Vr History/listUserViewVrHistory";
// import ViewUserViewVrHistory from "../Components/User View Vr History/viewUserViewVrHistory";

const UserViewVrHistoryRoutes = () => {
  return (
    <Routes>
      <Route
        path="/vr_history"
        element={<ListUserViewVrHistory />}
      />
      {/* <Route
        path="/user-view-vr-history/view/:id"
        element={<ViewUserViewVrHistory />}
      /> */}
    </Routes>
  );
};

export default UserViewVrHistoryRoutes;